/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { PostUsersAuth201, PostUsersAuth400, PostUsersAuthMutationRequest, PostUsersAuthMutationResponse } from '../entities/PostUsersAuth'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { userAuthRequestSchema } from './userAuthRequestSchema'
import { userAuthResponseSchema } from './userAuthResponseSchema'
import { z } from 'zod'

/**
 * @description Created
 */
export const postUsersAuth201Schema = z.lazy(() => userAuthResponseSchema) as unknown as ToZod<PostUsersAuth201>

/**
 * @description Bad Request
 */
export const postUsersAuth400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostUsersAuth400>

/**
 * @description Аутентификация
 */
export const postUsersAuthMutationRequestSchema = z.lazy(() => userAuthRequestSchema) as unknown as ToZod<PostUsersAuthMutationRequest>

export const postUsersAuthMutationResponseSchema = z.lazy(() => postUsersAuth201Schema) as unknown as ToZod<PostUsersAuthMutationResponse>